import { createAction, createReducer } from "@reduxjs/toolkit";
import frc from 'front-end-common';
import EngineStatusService from "../Services/EngineStatusService";

const { addDefaultHandlers, getDefaultState } = frc.utils.reducerTools;


export const engineStatusListFetch = createAction('engineStatus/list', (params) => ({
  payload: EngineStatusService.getStatusList(params)
}));

export const engineStatusErrorsFetch = createAction('engineStatus/errors', (params) => ({
  payload: EngineStatusService.getStatusJobsErrors(params)
}));

export const engineStatusExpensesFetch = createAction('engineStatus/expenses', (dates) => ({
  payload: EngineStatusService.getStatusJobsExpenses(dates)
}));

export const engineStatusAvgTimeFetch = createAction('engineStatus/avg_time', (params) => ({
  payload: EngineStatusService.getStatusJobsAvg(params)
}));

export const engineStatusSubscrFetch = createAction('engineStatus/subscr', (dates) => ({
  payload: EngineStatusService.getStatusJobsSubscr(dates)
}));

export const engineStatusWorkersFetch = createAction('engineStatus/workers', () => ({
  payload: EngineStatusService.getEnabledWorkers()
}));

const initialState = {
  list: getDefaultState(),
  errors: getDefaultState(),
  expenses: getDefaultState(),
  avgTime: getDefaultState(),
  subscr: getDefaultState(),
  workers: getDefaultState(),
}

export default createReducer(initialState, (builder) => {
  addDefaultHandlers(builder, engineStatusListFetch, 'list');
  addDefaultHandlers(builder, engineStatusErrorsFetch, 'errors');
  addDefaultHandlers(builder, engineStatusExpensesFetch, 'expenses');
  addDefaultHandlers(builder, engineStatusAvgTimeFetch, 'avgTime');
  addDefaultHandlers(builder, engineStatusSubscrFetch, 'subscr');
  addDefaultHandlers(builder, engineStatusWorkersFetch, 'workers');
})
